import { apiRequest } from './apiClient';

export type PinnedWidget = {
  id: string;
  title: string;
  body: string;
  sourceMessageId: string | null;
  sourceThreadId: string | null;
  target: string | null;
  createdAt: string;
};

export type PinWidgetInput = {
  title: string;
  body: string;
  sourceMessageId?: string;
  sourceThreadId?: string;
  target?: string;
};

/** Signed-in user's pins only — never household-combined. */
export async function listPinnedWidgets(): Promise<{ pinnedWidgets: PinnedWidget[] }> {
  return apiRequest('/pinned-widgets');
}

export async function pinWidget(
  input: PinWidgetInput,
): Promise<{ pinnedWidget: PinnedWidget; alreadyPinned: boolean }> {
  return apiRequest('/pinned-widgets', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function unpinWidget(id: string): Promise<{ ok: boolean; id: string }> {
  return apiRequest(`/pinned-widgets/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

/** Derive a short title + body from assistant markdown for pinning. */
export function pinFieldsFromAssistantContent(content: string): {
  title: string;
  body: string;
} {
  const plain = content
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/[#>*_`~\[\]]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  const sentences = plain
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const title = (sentences[0] ?? 'Pinned insight').slice(0, 80);
  const body = (sentences.slice(1).join(' ') || sentences[0] || 'Pinned from chat').slice(
    0,
    400,
  );
  return { title, body };
}
